import useSWR from "swr";
import type { CharacterSheetDnd5e } from "@/lib/rules/dnd5e/character/character-sheet";

const fetcher = async (url: string) => {
  const res = await fetch(url);
  if (!res.ok) {
    throw new Error("Failed to fetch character sheet");
  }
  return res.json();
};

export function useCharacterSheet(
  campaignId: string | null,
  actorId: string | null
) {
  const { data, error, isLoading, mutate } = useSWR<CharacterSheetDnd5e>(
    campaignId && actorId
      ? `/api/campaigns/${campaignId}/characters/${actorId}/sheet`
      : null,
    fetcher
  );
  return { sheet: data, isLoading, error, mutate };
}
